import { GetGiftAvailableUserIdResponse } from "../../api/v1/gift/available/[user_id]/getResponse"
import { UserReceivingGiftConditions } from "./UserReceivingGiftConditions"

export const adaptUserReceivingGiftConditions = (
  id: string,
  res: GetGiftAvailableUserIdResponse,
): UserReceivingGiftConditions => {
  return new UserReceivingGiftConditions({
    userId: id,
    conditions: {
      isActivateUser: res.is_activate_user,
      hasTieup: res.is_exist_tieup,
      hasAgreed: res.is_agreement,
    },
  })
}
